module.exports = __webpack_public_path__ + "components/login/static/background-1ce12c10b1cdb06225382f1a5b9af3d4.jpg";